import Swiper from "swiper";

export default function () {

  const swiper = new Swiper(".clean-slider", {
    slidesPerView: 1.2,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    allowTouchMove: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
        centeredSlides: true,
        allowTouchMove: false,
      }
    }
  });
}
